// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"15052b14","160":"7df50266","263":"0d8069e8","371":"91b43e25","402":"57288bd6","411":"8152a56b","419":"b5dd18a1","524":"19a6a6f3","683":"7147f35e","694":"006981f7","872":"ea88029d"}[chunkId] + ".js";
};